import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=007f2b2c&scoped=true&"
import script from "./TipTap.vue?vue&type=script&lang=js&"
export * from "./TipTap.vue?vue&type=script&lang=js&"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=007f2b2c&lang=scss&scoped=true&"
import style1 from "./TipTap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f2b2c",
  null
  
)

export default component.exports